export default __webpack_public_path__ + "3836361d8f140080e15ae065cdba3533.webp";